import axios from "axios";
import moment from "moment";

const publicInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
});

const agentAction = {
  // signIn: ({ commit }, message) => {
  //   return new Promise((resolve, reject) => {
  //     publicInstance
  //       .post("/login/agent/", {
  //         username: message.username,
  //         password: message.password,
  //       })
  //       .then((response) => {
  //         commit("SIGN_IN_AGENT", response.data.response);
  //         resolve(response.data.response);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  fetchUserList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      publicInstance
        .get("/api/users/list/agent")
        .then((response) => {
          console.log('getUserList Response:', response)
          commit('SET_ALL_USERS', response.data.response.data)

          return response.data.response.data
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchValidBrands: ({ commit }) => {
    return new Promise((resolve, reject) => {
      publicInstance
        .get("/api/car/p/brand")
        .then((response) => {
          commit("SET_CAR_BRANDS", response.data.brands);
          resolve(response.data.brands);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchValidYear: ({ commit }, car) => {
    return new Promise((resolve, reject) => {
      publicInstance
        .get(`/api/car/p/valid_year?brand=${car.brand}&model=${car.model}`)
        .then((response) => {
          console.log("fetchValidYear", response);
          commit("SET_VALID_YEARS", response.data.years);
          resolve(response.data.years);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchValidSubModel: ({ commit }, car) => {
    return new Promise((resolve, reject) => {
      publicInstance
        .get(
          `/api/car/p/valid_sub_model?brand=${car.brand}&model=${car.model}&year=${car.year}`
        )
        .then((response) => {
          console.log("fetchValidSubModel", response);
          commit("SET_VALID_SUB_MODELS", response.data.sub_models);
          resolve(response.data.sub_models);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchValidPrice: ({ commit }, car) => {
    return new Promise((resolve, reject) => {
      publicInstance
        .get("/api/car/p/valid_price", {
          params: {
            brand: car.brand,
            model: car.model,
            year: car.year,
            sub_model: car.sub_model,
          },
        })
        .then((response) => {
          console.log("fetchValidPrice", response);
          commit("SET_VALID_PRICE", response.data.price);
          resolve(response.data.price);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchRelatedModel: ({ commit }, obj) => {
    const config = {
      url: "",
      method: "get",
      data: {},
    };

    if (obj.car_brand && obj.car_model) {
      config.url = `api/car/p/valid_model/?car_brand=${obj.car_brand}&car_model=${obj.car_model}`;
    } else if (obj.car_brand && !obj.car_model) {
      config.url = `api/car/p/valid_model/?car_brand=${obj.car_brand}`;
    } else if (!obj.car_brand && obj.car_model) {
      config.url = `api/car/p/valid_model/?car_model=${obj.car_model}`;
    } else {
      throw new Error("Null Inputs");
    }

    return axios
      .request(config)
      .then((resp) => {
        console.log(
          "[CASES][Actions]fetchRelativeCarInformation Response:",
          resp.data.response
        );
        commit("SET_RELATIVE_CAR_MODEL", resp.data.response);

        /* Return */
        return Promise.resolve(resp.data.response);
      })
      .catch((err) => {
        console.log("[CASES][Actions]fetchRelativeCarInformation error:", err);

        return Promise.reject(err);
      });
  },
  fetchLeadChannel: () => {
    const config = {
      url: "api/leads/get_channel_list/",
      method: "get"
    };

    return axios
      .request(config)
      .then((resp) => {
        console.log(
          "[LEADS][Actions]fetchLeadChannel Response:",
          resp.data.response
        );

        /* Return */
        return Promise.resolve(resp.data.response);
      })
      .catch((err) => {
        console.log("[LEADS][Actions]fetchLeadChannel error:", err);

        return Promise.reject(err);
      });
  },
  fetchLeadDetailShort: (_, obj) => {
    const config = {
      url: "api/leads/detail_short/" + obj.lead_id,
      method: "get"
    };

    return axios
      .request(config)
      .then((resp) => {
        console.log(
          "[LEADS][Actions]fetchLeadDetailShort Response:",
          resp.data.response
        );

        /* Return */
        return Promise.resolve(resp.data.response);
      })
      .catch((err) => {
        console.log("[LEADS][Actions]fetchLeadDetailShort error:", err);

        return Promise.reject(err);
      });
  },
  createNewRecord: ({ commit }, lead) => {
    console.log("lead", lead);

    return new Promise((resolve, reject) => {
      axios
        .post("/api/leads/zoho/create/", {
          data: {
            Admin_Notes: lead.contact_time,
            Age: lead.age,
            Assigned_Admin: lead.zoho_id || "3291521000007903378", // Reg id
            Car_Brand: lead.brand,
            Car_Insurance_Expiration: lead.insurance_expiration,
            Car_Insurance_Category: lead.insurance_category,
            Car_Model: lead.model,
            Car_Year: lead.year,
            Car_License: lead.license,
            Customer_Name: {
              first_name: lead.first_name,
              last_name: lead.last_name,
            },
            Channel: "Agent",
            Credit_Bureau_Status: lead.black_list,
            Customer_career: lead.career,
            Date_field1: moment().format("D MMM YYYY"),
            Gender: lead.gender,
            Installment_Left: lead.installment_left,
            Lead_Form_ID: lead.Lead_Form_ID,
            Lead_Type: "Refinance",
            Loan_Paid: lead.loan_paid,
            Loan_Payment_Status: lead.loan_payment_status,
            Market_Price: lead.car_price,
            Monthly_Loan_Payment: lead.Monthly_Loan_Payment,
            Phone_1: lead.phone1.replace(/[\u200B-\u200D\uFEFF]/g, ""),
            Phone_2: lead.phone2.replace(/[\u200B-\u200D\uFEFF]/g, ""),
            Province: lead.province,
            Sub_Model: lead.sub_model,
            Surname: lead.last_name,
            ZipCode: lead.zipcode,
            LinkCarBookPage4: {
              title: lead.LinkCarBookPage4.zoho,
              url: lead.LinkCarBookPage4.signed_url,
              value: lead.LinkCarBookPage4.path,
            },
            LinkCarLicense: {
              title: lead.LinkCarLicense.zoho,
              url: lead.LinkCarLicense.signed_url,
              value: lead.LinkCarLicense.path,
            },
            LinkCarInsurance: {
              title: lead.LinkCarInsurance.zoho,
              url: lead.LinkCarInsurance.signed_url,
              value: lead.LinkCarInsurance.path,
            },
            LinkNationalId: {
              title: lead.LinkNationalId.zoho,
              url: lead.LinkNationalId.signed_url,
              value: lead.LinkNationalId.path,
            },
            LinkFace: {
              title: lead.LinkFace.zoho,
              url: lead.LinkFace.signed_url,
              value: lead.LinkFace.path,
            },
            ProductInterests: lead.interests,
          }
        })
        .then((response) => {
          console.log("createNewRecord", response);

          commit("SET_NEW_LEAD", response);
          resolve(response.data.response.detail);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  createNewRecordReg: ({ commit }, lead) => {
    console.log("lead", lead);
    console.log('temp_id', lead.temp_id)

    return new Promise((resolve, reject) => {
      axios
        .post("/api/leads/zoho/create/reg/", {
          data: {
            Admin_Notes: lead.contact_time,
            Age: lead.age,
            Assigned_Admin: lead.zoho_id || "3291521000007903378", // Reg id
            Car_Brand: lead.brand,
            Car_Insurance_Expiration: lead.insurance_expiration,
            Car_Insurance_Category: lead.insurance_category,
            Car_Model: lead.model,
            Car_Year: lead.year,
            Car_License: lead.license,
            Customer_Name: {
              first_name: lead.first_name,
              last_name: lead.last_name,
            },
            Channel: lead.channel,
            Credit_Bureau_Status: lead.black_list,
            Customer_career: lead.career,
            Date_field1: moment().format("D MMM YYYY"),
            Gender: lead.gender,
            Installment_Left: lead.installment_left,
            // Lead_Form_ID: lead.Lead_Form_ID,
            Lead_Type: "Refinance",
            Loan_Paid: lead.loan_paid,
            Loan_Payment_Status: lead.loan_payment_status,
            Market_Price: lead.car_price,
            Monthly_Loan_Payment: lead.Monthly_Loan_Payment,
            Phone_1: lead.phone1.replace(/[\u200B-\u200D\uFEFF]/g, ""),
            Phone_2: lead.phone2.replace(/[\u200B-\u200D\uFEFF]/g, ""),
            Province: lead.province,
            Sub_Model: lead.sub_model,
            Surname: lead.last_name,
            ZipCode: lead.zipcode,
            ProductInterests: lead.interests,
            Referral: lead.referral,
            Signature_Image: lead.signature || null
          },
          reg: {
            current_finance_id: lead.current_finance_id,
            tagged_admin: lead.tagged_admin,
            current_insurance: lead.current_insurance,
            car_type: lead.car_type,
            temp_id: lead.temp_id,
            type_lead: lead.type_lead,
            c2c_sales_name: lead.referral,
            kauto_product_select: lead.kauto_product_select
          }
        })
        .then((response) => {
          console.log("createNewRecord", response);

          commit("SET_NEW_LEAD", response);
          resolve(response.data.response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePDPA: (_, lead) => {
    console.log("lead", lead);

    return new Promise((resolve, reject) => {
      axios
        .post("/api/leads/update_pdpa/", lead)
        .then((response) => {
          console.log("updatePDPA", response);
          resolve(response.data.response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeLeadImage: ({ commit } , obj) => {
    console.log('obj : ', obj)
    commit("DEL_PUB_IMG", obj)

    return new Promise((resolve, reject) => {
      axios
        .post('api/leads/delete_lead_public_image/', {
          blob: obj.blob
        })
        .then((resp) => {
          console.log('removeLeadImage resp', resp)
          resolve(resp)
        })
        .catch((err) => {
          console.log('[LEAD][Actions]removeLeadImage:', err)
          reject(err)
        })
    })
  },
  fetchLeadPublicImg: ({ commit } , obj) => {
    console.log('obj : ', obj)
    commit("SET_PUB_IMG", obj)

    return axios.get(
      'api/leads/list_lead_public_img/?id=' + obj.id + '&type=' + obj.type
    )
  }
};

export default agentAction;
